export { DMS_MODULE, MODULE_API } from '../../constants';
export const NAME = <const>'PROrdersParts';
export const CRUMB_LABEL_KEY = 'edtPROrders';
export const CRUMB_LABEL_LIST = 'grdPROrdersParts';
export const LOCALSTORAGE_STATE_KEY = 'DMS3_STATE';
export const API_ND_AREA = 'Nd';
export const NdSklad = 'NdSklad';
